import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IFiber } from '@rfm/shared-interfaces';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FiberService } from '../../../../../shared/services/fiber-management/fiber.service.mjs';
import { TableModule } from 'primeng/table';
interface OrderDetail {
  title: string;
  description: string;
  extra: string;
  image: string;
}

interface OrderInfo {
  value: string;
  label: string;
}

interface OrderItem {
  name: string;
  size: string;
  price: number;
}


@Component({
  selector: 'app-fiber-view',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, ProgressSpinnerModule, TableModule],
  templateUrl: './fiber-view.component.html',
  styleUrls: ['./fiber-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FiberViewComponent implements OnInit {
  fiber: IFiber | null = null; // Store the selected fiber details
  isLoading = false;
  orderDetails: OrderDetail[] = [
    {
      title: 'Service Details',
      description: 'Website Development',
      extra: 'Includes design, development, and deployment',
      image: '/images/service.png'
    },
    {
      title: 'Billing Details',
      description: 'Invoice #INV12345',
      extra: 'Due date: 15 Feb, 2025',
      image: '/images/billing.png'
    },
    {
      title: 'Payment Details',
      description: 'Credit Card Payment',
      extra: 'Paid on: 02 Feb, 2025',
      image: '/images/payment.png'
    },
    {
      title: 'Customer Info',
      description: 'John Doe',
      extra: 'john.doe@example.com',
      image: '/images/customer.png'
    }
  ];

  orderInfo: OrderInfo[] = [
    { value: '#TWT501', label: 'Order ID' },
    { value: '02 Jan, 2025', label: 'Order Date' },
    { value: '09 Jan, 2025', label: 'Delivery Date' },
    { value: '$120.49', label: 'Order Amount' },
    { value: 'Delivered', label: 'Order Status' }
  ];

  orderItems: OrderItem[] = [
    { name: 'Website Design Package', size: 'Standard', price: 80.00 },
    { name: 'Hosting (1 Year)', size: 'Basic', price: 30.00 },
    { name: 'Domain Registration', size: '1 Year', price: 10.00 }
  ];
  constructor(private fiberService: FiberService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loadFiber(id);
    }
  }

  loadFiber(id: string): void {
    this.fiberService.get(id)
      .then((response) => {
        this.fiber = response?.data ?? null; // Handle null or undefined data
      })
      .catch((error) => {
        console.error('Error fetching fiber details:', error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}

